import { Skeleton } from "../ui/skeleton";

/**
 * Placeholder for a figure that is on its way: the fence is still streaming
 * in, or mermaid is loading or drawing it. Shaped like a small diagram
 * (title, three connected nodes) so the reader knows a picture is coming,
 * not a paragraph. Sized like a typical figure so the message doesn't jump
 * when the real one lands.
 */
export function FigureSkeleton({ kind }: { readonly kind: "chart" | "diagram" }) {
  return (
    <div
      className="chat-markdown-figure-skeleton"
      data-figure-skeleton={kind}
      role="status"
      aria-label={kind === "chart" ? "Chart loading" : "Diagram loading"}
    >
      <Skeleton className="chat-markdown-figure-skeleton-title" />
      {kind === "chart" ? (
        <div className="chat-markdown-figure-skeleton-bars">
          {[56, 78, 44, 88, 64, 72].map((height, index) => (
            <Skeleton key={index} style={{ height: `${height}%` }} />
          ))}
        </div>
      ) : (
        <div className="chat-markdown-figure-skeleton-nodes">
          <Skeleton className="chat-markdown-figure-skeleton-node" />
          <Skeleton className="chat-markdown-figure-skeleton-edge" />
          <Skeleton className="chat-markdown-figure-skeleton-node is-decision" />
          <Skeleton className="chat-markdown-figure-skeleton-edge" />
          <Skeleton className="chat-markdown-figure-skeleton-node" />
        </div>
      )}
    </div>
  );
}
